import React from 'react'
import logoSC from "../Imagenes/logoSCTKD.webp"
import compBg from "../Imagenes/comp-bg.webp"
import { Typography, Button } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';

const Styles = makeStyles({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#0a0d14",
    position: "relative",
    padding: "20px 16px 60px 16px",
    boxSizing: "border-box",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  bg: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${compBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    opacity: 0.25,
    zIndex: 0
  },
  content: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    maxWidth: 360,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  header: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 16
  },
  logo: {
    width: 90,
    height: "auto",
    objectFit: "contain"
  },
  title: {
    color: "#ffffff",
    fontSize: 20,
    fontWeight: 800,
    fontStyle: "italic",
    textTransform: "uppercase",
    letterSpacing: 1,
    textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)"
  },
  backBtn: {
    width: "100%",
    padding: "14px 24px",
    borderRadius: 12,
    textTransform: "uppercase",
    fontWeight: 700,
    fontSize: 15,
    color: "#ffffff",
    letterSpacing: 1,
    background: "linear-gradient(180deg, #990000 0%, #660000 100%)",
    border: "1px solid rgba(255, 0, 0, 0.3)",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
    cursor: "pointer",
    transition: "transform 0.2s ease, filter 0.2s ease",
    outline: "none",
    marginBottom: 24,
    "&:active": {
      transform: "scale(0.98)",
      filter: "brightness(1.2)"
    }
  },
  listCard: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: "rgba(20, 24, 33, 0.65)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderRadius: 16,
    padding: 16,
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
    boxSizing: "border-box"
  },
  cardTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#ffffff",
    fontWeight: 700,
    fontSize: 15,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    paddingBottom: 10,
    marginBottom: 4
  },
  listHeader: {
    display: "flex",
    alignItems: "center",
    padding: "8px 0",
    borderBottom: "1px solid rgba(255, 255, 255, 0.08)"
  },
  row: {
    display: "flex",
    alignItems: "center",
    padding: "10px 0",
    borderBottom: "1px solid rgba(255, 255, 255, 0.06)"
  },
  rowHighlight: {
    background: "rgba(153, 0, 0, 0.35)",
    borderRadius: 8,
    paddingLeft: 8,
    paddingRight: 8
  },
  colPuesto: {
    width: "12%",
    color: "#a0aec0",
    fontSize: 13,
    fontWeight: 700,
    textAlign: "center",
    flexShrink: 0
  },
  colNombre: {
    width: "50%",
    color: "#ffffff",
    fontSize: 14,
    fontWeight: 600,
    textTransform: "capitalize",
    paddingLeft: 8,
    boxSizing: "border-box"
  },
  colCategoria: {
    width: "23%",
    color: "#a0aec0",
    fontSize: 12,
    textAlign: "center",
    textTransform: "capitalize"
  },
  colPuntos: {
    width: "15%",
    color: "#39ff14",
    fontSize: 14,
    fontWeight: 700,
    textAlign: "right",
    textShadow: "0 0 8px rgba(57, 255, 20, 0.5)"
  }
})

function RankingListado() {
  const classes = Styles()
  const navigate = useNavigate()
  const { state } = useLocation()
  const datosRanking = state?.datosRanking || {}
  const competidor = state?.competidor || {}
  const lista = Array.isArray(datosRanking.data) ? datosRanking.data : []

  return (
    <div className={classes.root}>
      <div className={classes.bg} />
      <div className={classes.content}>
        <div className={classes.header}>
          <img src={logoSC} alt="logo" className={classes.logo} />
          <Typography className={classes.title}>
            {datosRanking.liga_name || "RANKING DE LIGA"}
          </Typography>
        </div>

        <Button className={classes.backBtn} onClick={() => navigate(-1)}>
          Volver
        </Button>

        <div className={classes.listCard}>
          <div className={classes.cardTitleContainer}>
            <span>Ranking de Liga</span>
          </div>

          <div className={classes.listHeader}>
            <span className={classes.colPuesto}>#</span>
            <span className={classes.colNombre}>Nombre</span>
            <span className={classes.colCategoria}>Categoría</span>
            <span className={classes.colPuntos}>Pts</span>
          </div>

          {lista.map((x, idx) => {
            const destacado = x.dni === competidor.dni
            return (
              <div key={idx} className={`${classes.row} ${destacado ? classes.rowHighlight : ""}`}>
                <span className={classes.colPuesto}>{x.puesto}</span>
                <span className={classes.colNombre}>{x.nombre + " " + x.apellido}</span>
                <span className={classes.colCategoria}>{x.categoria}</span>
                <span className={classes.colPuntos}>{x.puntos} pts.</span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default RankingListado
